import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './two-column-resposive-block.scss.js';

const IMAGE_BLOCK_COMPONENT = 'image-block, image-block-container';
const findElementDeep = (parent, selector) => {
    var _a;
    if (parent instanceof HTMLElement && parent.matches(selector)) {
        return parent;
    }
    if (!(parent instanceof HTMLElement)) {
        return null;
    }
    const shadowMatch = (_a = parent.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(selector);
    if (shadowMatch) {
        return shadowMatch;
    }
    for (const child of parent.childNodes) {
        if (child instanceof HTMLElement) {
            const found = findElementDeep(child, selector);
            if (found) {
                return found;
            }
        }
    }
    return null;
};
const applyImageBlockFigureStyles = (element) => {
    var _a, _b;
    const figure = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('figure.image-block');
    const img = (_b = element.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('figure.image-block img');
    if (figure) {
        figure.style.width = '100%';
        figure.style.height = '100%';
        figure.style.maxWidth = '100%';
    }
    if (img) {
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center';
    }
};
const applyImageBlockContainerStyles = (element) => {
    var _a, _b, _c, _d, _e;
    const mediaWrapper = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.media-wrapper');
    const genericImage = (_b = element.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('generic-image');
    const genericWrapper = (_c = genericImage === null || genericImage === void 0 ? void 0 : genericImage.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.wrapper');
    const genericRoot = (_d = genericImage === null || genericImage === void 0 ? void 0 : genericImage.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('div');
    const img = (_e = genericImage === null || genericImage === void 0 ? void 0 : genericImage.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('img.media');
    if (mediaWrapper) {
        mediaWrapper.style.width = '100%';
        mediaWrapper.style.maxWidth = '100%';
        mediaWrapper.style.height = '100%';
    }
    if (genericImage) {
        genericImage.style.width = '100%';
        genericImage.style.height = '100%';
    }
    if (genericRoot) {
        genericRoot.style.width = '100%';
        genericRoot.style.height = '100%';
    }
    if (genericWrapper) {
        genericWrapper.style.width = '100%';
        genericWrapper.style.height = '100%';
        genericWrapper.style.aspectRatio = 'auto';
    }
    if (img) {
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center';
    }
};
const applyImageBlockStyles = (element) => {
    const tagName = element.tagName.toLowerCase();
    if (tagName === 'image-block') {
        applyImageBlockFigureStyles(element);
        return;
    }
    if (tagName === 'image-block-container') {
        applyImageBlockContainerStyles(element);
    }
};
const setDimensions = (element, height) => {
    const target = element;
    target.style.transition = 'none';
    target.style.height = `${height}px`;
    target.style.minHeight = `${height}px`;
    target.style.width = '100%';
    target.style.boxSizing = 'border-box';
};
const applyTargetStyles = (targetElement, height) => {
    if (!targetElement) {
        return;
    }
    setDimensions(targetElement, height);
    if (['image-block', 'image-block-container'].includes(targetElement.tagName.toLowerCase())) {
        applyImageBlockStyles(targetElement);
    }
};
const getTargetSlot = (element, leftElements, rightElements) => leftElements.some(el => element && el.contains(element))
    ? rightElements
    : leftElements;
const applyHalfHeightImageStyles = (imageBlockElement, blockHeight) => {
    const { width } = imageBlockElement.getBoundingClientRect();
    const halfHeight = blockHeight / 2;
    if (width <= 0 || halfHeight <= 0) {
        return;
    }
    const resizedBlock = imageBlockElement;
    const aspectRatio = `${width} / ${halfHeight}`;
    resizedBlock.style.aspectRatio = aspectRatio;
    resizedBlock.style.removeProperty('height');
    resizedBlock.style.removeProperty('min-height');
    const img = resizedBlock.querySelector('img');
    if (img) {
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center';
    }
};
const processBlock = (blockElement, leftElements, rightElements, isHalfHeight = false) => {
    if (!blockElement) {
        return;
    }
    const blockHeight = Math.round(blockElement.getBoundingClientRect().height);
    const otherSlotElements = getTargetSlot(blockElement, leftElements, rightElements);
    const imageBlockElement = otherSlotElements
        .map(el => findElementDeep(el, IMAGE_BLOCK_COMPONENT))
        .find(Boolean) || null;
    if (!imageBlockElement) {
        return;
    }
    if (window.innerWidth <= 768 && isHalfHeight) {
        applyHalfHeightImageStyles(imageBlockElement, blockHeight);
        return;
    }
    applyTargetStyles(imageBlockElement, window.innerWidth <= 768 && isHalfHeight ? blockHeight / 2 : blockHeight);
};
class TwoColumnResposiveBlock extends s {
    constructor() {
        super(...arguments);
        this.ctaStyleLeft = 'primary';
        this.ctaStyleRight = 'primary';
        this.ctaAlignSlotLeft = 'center';
        this.ctaAlignSlotRight = 'center';
        this.hasLeftCta = false;
        this.hasRightCta = false;
    }
    firstUpdated() {
        const leftSlot = this.shadowRoot.querySelector('slot[name="left"]');
        const rightSlot = this.shadowRoot.querySelector('slot[name="right"]');
        const leftCtaSlot = this.shadowRoot.querySelector('slot[name="cta-left"]');
        const rightCtaSlot = this.shadowRoot.querySelector('slot[name="cta-right"]');
        const syncResponsiveGrid = (leftElements, rightElements) => {
            const responsiveGridElement = [...leftElements, ...rightElements]
                .map(el => findElementDeep(el, 'responsive-grid'))
                .find(Boolean) || null;
            if (!responsiveGridElement) {
                return false;
            }
            const categoryTileElement = findElementDeep(responsiveGridElement, 'category-tile-small');
            const smallTileContainer = categoryTileElement
                ? findElementDeep(categoryTileElement, 'a.small-tile-container')
                : null;
            const smallTileElement = smallTileContainer
                ? findElementDeep(smallTileContainer, 'div.small-tile')
                : null;
            if (!smallTileElement) {
                return true;
            }
            const smallTileHeight = smallTileElement.offsetHeight || 0;
            const otherSlotElements = getTargetSlot(responsiveGridElement, leftElements, rightElements);
            const imageBlockElement = otherSlotElements
                .map(el => findElementDeep(el, IMAGE_BLOCK_COMPONENT))
                .find(el => el) || null;
            const crossSellElement = otherSlotElements
                .map(el => findElementDeep(el, 'cross-sell'))
                .find(el => el) || null;
            applyTargetStyles(imageBlockElement, window.innerWidth <= 768 ? smallTileHeight / 2 : smallTileHeight);
            if (imageBlockElement) {
                imageBlockElement.style.marginTop = '17px';
            }
            if (crossSellElement === null || crossSellElement === void 0 ? void 0 : crossSellElement.shadowRoot) {
                const crossSellArticle = crossSellElement.shadowRoot.querySelector('article.multicolumn-cross');
                applyTargetStyles(crossSellArticle, smallTileHeight);
            }
            return true;
        };
        const syncGeneralBlocks = (leftElements, rightElements) => {
            const findElementInSlots = (selector) => [...leftElements, ...rightElements]
                .map(el => findElementDeep(el, selector))
                .find(Boolean) || null;
            processBlock(findElementInSlots('title-link-block'), leftElements, rightElements, true);
            processBlock(findElementInSlots('.link-button-collection-block'), leftElements, rightElements);
            processBlock(findElementInSlots('video-block'), leftElements, rightElements);
        };
        const syncHeightsAndWidths = () => {
            setTimeout(() => {
                const leftElements = leftSlot.assignedElements({ flatten: true });
                const rightElements = rightSlot.assignedElements({ flatten: true });
                if (syncResponsiveGrid(leftElements, rightElements)) {
                    return;
                }
                syncGeneralBlocks(leftElements, rightElements);
            }, 0);
        };
        this.mutationObserver = new MutationObserver(() => {
            syncHeightsAndWidths();
        });
        const syncCtaVisibility = () => {
            const leftCtaCount = leftCtaSlot
                ? leftCtaSlot.assignedElements({ flatten: true }).length
                : this.querySelectorAll('[slot="cta-left"]').length;
            const rightCtaCount = rightCtaSlot
                ? rightCtaSlot.assignedElements({ flatten: true }).length
                : this.querySelectorAll('[slot="cta-right"]').length;
            this.hasLeftCta = leftCtaCount > 0;
            this.hasRightCta = rightCtaCount > 0;
        };
        this.resizeObserver = new ResizeObserver(syncHeightsAndWidths);
        leftSlot.addEventListener('slotchange', syncHeightsAndWidths);
        rightSlot.addEventListener('slotchange', syncHeightsAndWidths);
        leftCtaSlot === null || leftCtaSlot === void 0 ? void 0 : leftCtaSlot.addEventListener('slotchange', syncCtaVisibility);
        rightCtaSlot === null || rightCtaSlot === void 0 ? void 0 : rightCtaSlot.addEventListener('slotchange', syncCtaVisibility);
        window.addEventListener('resize', syncHeightsAndWidths);
        [leftSlot, rightSlot].forEach(slot => {
            slot.assignedElements().forEach(element => {
                this.mutationObserver.observe(element, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
            });
        });
        syncCtaVisibility();
        syncHeightsAndWidths();
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.mutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    static renderCTA(slotName, ctaType, ctaAlign, hasContent) {
        if (!hasContent)
            return null;
        return $ `<div class="cta-wrapper cta-${ctaType} align-${ctaAlign}"><slot name="${slotName}"></slot></div>`;
    }
    render() {
        return $ `<div class="container-responsive has-divider"><div class="column"><div class="slot-container"><slot name="left"></slot>${TwoColumnResposiveBlock.renderCTA('cta-left', this.ctaStyleLeft, this.ctaAlignSlotLeft, this.hasLeftCta)}</div></div><div class="column"><div class="slot-container"><slot name="right"></slot>${TwoColumnResposiveBlock.renderCTA('cta-right', this.ctaStyleRight, this.ctaAlignSlotRight, this.hasRightCta)}</div></div></div>`;
    }
}
TwoColumnResposiveBlock.styles = [css_248z];
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleLeft", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleRight", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotLeft", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotRight", void 0);
__decorate([
    t()
], TwoColumnResposiveBlock.prototype, "hasLeftCta", void 0);
__decorate([
    t()
], TwoColumnResposiveBlock.prototype, "hasRightCta", void 0);
customElements.define('two-column-resposive-block', TwoColumnResposiveBlock);

export { TwoColumnResposiveBlock };
